import React, { FC } from 'react';
import Alert from '@material-ui/lab/Alert';

interface Props {
    severity: "success" | "info" | "warning" | "error" | undefined;
    className?: string;
    style?: React.CSSProperties;
}

const AlertComponent: FC<Props> = p => {
    return (
        <Alert
            severity={p.severity}
            className={p.className}
            style={p.style}
        >
            { p.children }
        </Alert>   
    )
}

export default AlertComponent;

